import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { ModalBaseComponent, RoleNames, StringListItemModel, ValidationHandlerService } from 'lib/Vestra.shared';
import { CoreService, UserModel } from 'src/app/services/api-services';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss'],
})
export class UserEditComponent extends ModalBaseComponent {
    constructor(private bsModalRef: BsModalRef, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }
    public isPartnerRoleSelected: boolean;


    //input properties
    public title: string;
    public item: UserModel;
    public roles: StringListItemModel[];
    public partners: StringListItemModel[];



    private getFormGroup(): FormGroup {
        return new FormGroup({
            name: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.required, Validators.email]),
            role: new FormControl('', Validators.required),
            partnerId: new FormControl(''),
            isActive: new FormControl(true),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public init() {
        this.form = this.getFormGroup();
        this.roles = this.roles.filter(role => role.text !== RoleNames.VestraUser);
        this.getPartners();
        if (this.item) {
            this.form.patchValue(this.item);
            if(this.item.partnerId > 0)
            {
                this.form.get('partnerId').setValue(this.item.partnerId.toString());
                this.isPartnerRoleSelected = true;
                this.updateFormControl(true);
            }
            else
            {
                this.form.get('partnerId').setValue("");
            }
        }
        console.log(this.item)
        this.form.get('role').valueChanges.subscribe(role => {
            const isPartner = (role === RoleNames.Partner);
            this.updateFormControl(isPartner);
        });
    }
    public ngAfterViewInit() {
        this.init();
    }

    public onSave = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            let itemToSave: UserModel = <UserModel>this.form.getRawValue();
            itemToSave.id = this.item?.id;
            itemToSave.isActive = itemToSave.isActive || false;
            if(!this.isPartnerRoleSelected)
            {
                itemToSave.partnerId = 0;
            }

            return this.handleSpinner(
                firstValueFrom(this.coreService.updateUser(itemToSave))
                    .then(res => {
                        this.onClose(this.bsModalRef, 'save_success');
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.form);
                    })
            );
        }
    };
    private getPartners()
    {
        firstValueFrom(this.coreService.getPartners())
        .then(res => {
            this.partners = res.result;
        })
        .catch((err: HttpErrorResponse) => {
            this.validationHandlerService.handleServerError(err);
        });
    }
    private updateFormControl(isPartner: boolean)
    {
        this.isPartnerRoleSelected = isPartner;
        const controlToValidate = this.form.get('partnerId'); 
        if (controlToValidate) {
            if (isPartner) {
                controlToValidate.setValidators([Validators.required]);
            } else {
                controlToValidate.clearValidators();
            }
            controlToValidate.updateValueAndValidity();
        }
    }
}
